// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__NPuJu","inner":"Footer_inner__11Fv0","nextIcon":"Footer_nextIcon__2Bk4Q","innerLeft":"Footer_innerLeft__3SpPK"};